export const PAGE_VIEW = 'virtualPageView'
export const FORM_1_SUBMIT = 'form1.submit'
export const FORM_2_SUBMIT = 'form2.submit'
export const FORM_2_SUBMIT_SUCCESSFUL = 'form2.submit.successful'
export const FORM_2_SUBMIT_ERROR = 'form2.submit.error'
export const CTA_CLICK = 'cta_button_click'

// Page types
export const FORM_PAGE = 'form_page'
